import { CallToAction } from "../CTA/CallToActionButton";

export const BannerInfoCard = ({
  imageUrl,
  imageAlt,
  headerText,
  subtitle,
  content,
  isEven,
  ctas,
  formattedSectionStyles
}) => {

  return (
    <article
      className={`flex flex-col gap-12  ${formattedSectionStyles?.cardStyling?.backgroundColor || formattedSectionStyles?.inverseColor} ${
        isEven ? "sm:flex-row-reverse" : "sm:flex-row"
      } rounded-bottom-[50px] md:rounded-[50px] md:max-h-[400px] max-w-[1200px] `}
    >
      <div className={`relative md:block md:flex-[6] md:basis-6/12 mx-auto `}>
        <img
          src={imageUrl}
          alt={imageAlt}
          className="object-cover w-full h-full block rounded-[50px] "
          style={{
            aspectRatio: "3 / 3.5",
          }}
          loading="lazy"
        />
      </div>

      <div className="md:flex-[6] md:basis-6/12 flex flex-col justify-start text-center">
        {subtitle && (
          <span className={`text-is2_md ${formattedSectionStyles.headerStyling}`}>
            {subtitle}
          </span>
        )}
        {headerText && (
          <h1 className={`${formattedSectionStyles.headerStyling} mt-2 mb-9 mx-10 md:mx2`}>
            {headerText}
          </h1>
        )}
        <div className="[&_p]:text-is2-gray-150 [&_a]:text-is2-blue [&_a]:no-underline flex flex-col h-full justify-between md:px-6">
          {content}
        </div>

        {ctas && ctas.length > 0 && (
          <div className="flex flex-col gap-4  mt-8 ">
            {ctas.map((cta, index) => (
              <CallToAction
                key={`${cta.title}-${index}`}
                title={cta.buttonText || cta.title}
                {...cta}
              />
            ))}
          </div>
        )}
      </div>
    </article>
  );
};
